import PropTypes from "prop-types";
import React, { useRef } from "react";

import { HotelTileScript, ROCKET_WIDGET_ID } from "../HotelTileScript";
import styles from "./HotelContainer.module.scss";

/**
 * HotelContainer will render an iframe with data constructed in HotelTileScript.
 */
export const HotelContainer = (props) => {
  const {
    className,
    dataAttributes = {},
    iFrameIdentifier = "default",
    checkinDate,
    checkoutDate,
    hotelIFrameData = {},
    hotelLocation,
    language = "en_us",
    onCrossSellReady,
  } = props;
  const rootRef = useRef(null);
  const iFrameData = {
    default: {
      id: "hotel-tile",
      style: {
        display: "inline-block",
      },
    },
    hotelTile: {
      id: "hotel-tile",
      style: {
        display: "inline-block",
      },
    },
    wideBookingDotComBanner: {
      id: "wideBookingDotComBanner",
    },
    ...dataAttributes,
  };

  return (
    <div className={className} {...iFrameData[iFrameIdentifier]} ref={rootRef}>
      <div id={ROCKET_WIDGET_ID} className={styles.crossSellRoot} />
      <HotelTileScript {...getProps()} />
    </div>
  );

  function getProps() {
    return {
      checkinDate,
      checkoutDate,
      formType: iFrameIdentifier,
      hotelIFrameData,
      hotelLocation,
      language,
      dataContainer: dataAttributes,
      onReady: onCrossSellReady,
    };
  }
};

HotelContainer.propTypes = {
  /** Date for the hotel check-in, should be in format YYYY-MM-DD or a valid date string */
  checkinDate: PropTypes.string,
  /** Date for the hotel check-out, should be in format YYYY-MM-DD or a valid date string */
  checkoutDate: PropTypes.string,
  /** Additional classes for positioning the component. */
  className: PropTypes.string,
  /** additional attributes provided to the component. This will contain the id of the script tag that was generated using
   * HotelTileScript and some additional style like inline-block.
   */
  dataAttributes: PropTypes.object,
  /** Pass bootstrapped app settings data in from the SPA here */
  hotelIFrameData: PropTypes.object,
  /** Location code for the hotel search (airport code) */
  hotelLocation: PropTypes.string,
  /** Indicates what set of data the iframe utilizes. */
  iFrameIdentifier: PropTypes.oneOf([
    "default",
    "hotelTile",
    "hotelTileExpired",
    "hotelTileMboxEnabled",
    "landing",
    "wideBookingDotComBanner",
  ]),
  /** Language preference for the widget content */
  language: PropTypes.string,
  /** Callback function to execute when the cross-sell is ready (optional) */
  onCrossSellReady: PropTypes.func,
};
